import { render, staticRenderFns } from "./LiveBox.vue?vue&type=template&id=5c2249d2"
import script from "./LiveBox.vue?vue&type=script&lang=js"
export * from "./LiveBox.vue?vue&type=script&lang=js"
import style0 from "./LiveBox.vue?vue&type=style&index=0&id=5c2249d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_webpack@5.107.2__lodash@4.18.1_react-dom@16.2.0_rea_78eced9430f46a1a0ce5e8103c760d82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports